export default __webpack_public_path__ + "static/media/ic_huobi.22fdcff5.svg";